import React, { useEffect, useState } from "react";
import {
  ButtonAddHLPure,
  ButtonHLPure,
  DialogSystemGLPure,
  DialogYesNoHLPure,
  FilterHLPure,
  GridHLPure,
  HeaderHLPure,
  InputHLPure,
  LabelModalPure,
  SearchBarHLPure,
  SimpleLoading,
  DropDownBtnHLPure
} from "../../pures";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import "./AdministrateInvitedUsers.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  DomainService,
  LocalStorageService,
  UserInvitedService,
} from "../../../services";
import moment from "moment";
import { emailRegex } from "../../../utils";
import { useTranslation } from "react-i18next";

const AdministrateInvitedUsers = (props) => {
  const userInvitedService = new UserInvitedService(
    process.env.REACT_APP_MIFIRMA_API
  );
  const domainService = new DomainService(process.env.REACT_APP_MIFIRMA_API);
  const { t } = useTranslation();
  const localStorageService = new LocalStorageService();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState({});
  const [invitedUsers, setInvitedUsers] = useState({
    filteredUsers: [],
    originalUsers: [],
  });
  const [domains, setDomains] = useState([]);
  const mobile = useMediaQuery("(max-width: 910px)");
  const tinyMobile = useMediaQuery("(max-width:560px)");
  const [filterAndSearchOptions, setFilterAndSearchOptions] = useState({
    filterSearch: "",
    filterOptions: "",
  });
  const [showCreatingUser, setShowCreatingUser] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [propsDialog, setPropsDialog] = useState({
    loading: false,
    completed: false,
    error: false,
    warning: false,
    message: "",
  });
  const [showNoPasswordConfirm, setShowNoPasswordConfirm] = useState(false);
  const [noPasswordConfirmData, setNoPasswordConfirmData] = useState({
    user: null,
    isActivating: false,
  });
  const [showResendInvitationConfirm, setShowResendInvitationConfirm] = useState(false);
  const [resendInvitationUser, setResendInvitationUser] = useState(null);
  const [invitedUserData, setInvitedUserData] = useState({
    invitedEmail: "",
    fullName: "",
  });
  const filterOptions = [
    {
      optionName: t("administrateInvitedUsers.options.all"),
      status: "all",
    },
    {
      optionName: t("administrateInvitedUsers.options.active"),
      status: "active",
    },
    {
      optionName: t("administrateInvitedUsers.options.inactive"),
      status: "inactive",
    },
  ];
  let history = useHistory();
  const token = localStorageService.getLocalStorageItem("token").idToken;

  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
    justifyContent: "start",
  };

  const changeStateDialog = (property, value) =>
    setPropsDialog({ ...propsDialog, [property]: value });

  const filterUsers = (value) => {
    switch (value) {
      case "all":
        setInvitedUsers({
          ...invitedUsers,
          filteredUsers: invitedUsers.originalUsers.filter(
            (users) =>
              users.email
                .toLowerCase()
                .includes(filterAndSearchOptions.filterSearch.toLowerCase()) ||
              users.name
                .toLowerCase()
                .includes(filterAndSearchOptions.filterSearch.toLowerCase())
          ),
        });
        break;
      case "active":
        setInvitedUsers({
          ...invitedUsers,
          filteredUsers: invitedUsers.originalUsers.filter(
            (users) =>
              users.status &&
              (users.email
                .toLowerCase()
                .includes(filterAndSearchOptions.filterSearch.toLowerCase()) ||
                users.name
                  .toLowerCase()
                  .includes(filterAndSearchOptions.filterSearch.toLowerCase()))
          ),
        });
        break;
      case "inactive":
        setInvitedUsers({
          ...invitedUsers,
          filteredUsers: invitedUsers.originalUsers.filter(
            (users) =>
              !users.status &&
              (users.email
                .toLowerCase()
                .includes(filterAndSearchOptions.filterSearch.toLowerCase()) ||
                users.name
                  .toLowerCase()
                  .includes(filterAndSearchOptions.filterSearch.toLowerCase()))
          ),
        });
        break;
      default:
        break;
    }
  };

  const searchUsers = (value) => {
    let usersCopy = [...invitedUsers.originalUsers];
    usersCopy = usersCopy.filter(
      (item) =>
        item.email.toLowerCase().includes(value.toLowerCase()) ||
        item.name.toLowerCase().includes(value.toLowerCase())
    );
    if (filterAndSearchOptions.filterOptions === "active")
      usersCopy = usersCopy.filter((users) => users.status);
    else if (filterAndSearchOptions.filterOptions === "inactive")
      usersCopy = usersCopy.filter((users) => !users.status);
    setInvitedUsers({ ...invitedUsers, filteredUsers: usersCopy });
  };

  const updateUserData = (property, value) =>
    setInvitedUserData({ ...invitedUserData, [property]: value });
  const statusCell = ({ dataItem }) => (
    <td>
      <div style={{ fontWeight: 600 }}>
        <span
          style={
            dataItem["status"] ? { color: "#427FBA" } : { color: "#AAAFBA" }
          }
        >
          {dataItem["status"] ? t("administrateInvitedUsers.options.active") : t("administrateInvitedUsers.options.inactive")}
        </span>
      </div>
    </td>
  );

  const getDomains = async () => {
    const domains = await domainService.getDomains(token);
    setDomains(domains.map((item) => item.name));
  };

  const getUsers = async () => {
    try {
      const usersInvited = await userInvitedService.getInvitedUsers(
        token,
        "disabled"
      );
      if (usersInvited.statusCode !== 200)
        return (() => {
          changeStateDialog("error", true);
          setTimeout(() => {
            changeStateDialog("error", false);
            history.push("/configuration");
          }, 2500);
        })();
      usersInvited.data.forEach((item) => {
        let fullDateStart = new Date(item.lastInteraction);
        let dateStart = fullDateStart.getDate();
        let monthStart = fullDateStart.getMonth() + 1;
        let yearStart = fullDateStart.getFullYear();
        item.lastInteraction = `${dateStart}/${monthStart}/${yearStart}`;

        let arraySignRequestExpirationDate = item.lastInteraction.split("/");
        let dateParseExpirationDate =
          arraySignRequestExpirationDate[0] +
          "/" +
          moment(arraySignRequestExpirationDate[1])
            .format("MMM")
            .replace(/\./g, "") +
          "/" +
          arraySignRequestExpirationDate[2];
        item.lastInteraction = dateParseExpirationDate;

        item.isSignerNoPassword = item.noPasswordRequired
      });
      setIsLoading(false);
      setInvitedUsers({
        ...invitedUsers,
        filteredUsers: usersInvited.data,
        originalUsers: usersInvited.data,
      });
    } catch (e) {
      return (() => {
        changeStateDialog("error", true);
        setTimeout(() => {
          changeStateDialog("error", false);
          history.push("/configuration");
        }, 2500);
      })();
    }
  };

  const createUser = async () => {
    changeStateDialog("loading", true);
    for (const key in invitedUserData) {
      if (!invitedUserData[key])
        return (() => {
          changeStateDialog("loading", false);
          changeStateDialog("error", true);
          setTimeout(() => {
            changeStateDialog("error", false);
          }, 2500);
        })();
      if (key === "invitedEmail") {
        if (!emailRegex.test(invitedUserData[key]))
          return (() => {
            changeStateDialog("loading", false);
            changeStateDialog("error", true);
            setTimeout(() => {
              changeStateDialog("error", false);
            }, 2500);
          })();
        if (domains.includes(invitedUserData[key].split("@")[1]))
          return (() => {
            setPropsDialog({
              ...propsDialog,
              message:
                t("administrateInvitedUsers.errors.domain"),
              warning: true,
              loading: false,
            });
            setTimeout(() => {
              changeStateDialog("warning", false);
            }, 2500);
          })();
      }
    }

    try {
      const userInvitedCreated = await userInvitedService.createUserInvited(
        invitedUserData.invitedEmail,
        invitedUserData.fullName,
        token
      );

      if (userInvitedCreated.statusCode !== 200)
        return (() => {
          changeStateDialog("loading", false);
          changeStateDialog("error", true);
          setTimeout(() => {
            changeStateDialog("error", false);
          }, 2500);
        })();

      if (userInvitedCreated.data.customStatus === 1) {
        if (userInvitedCreated.data.userInvited.status)
          return (() => {
            setPropsDialog({
              ...propsDialog,
              loading: false,
              message: t("administrateInvitedUsers.user.exist"),
              warning: true,
            });
            setTimeout(() => {
              changeStateDialog("warning", false);
              changeStateDialog("message", "");
            }, 2500);
          })();
        else
          return (() => {
            setPropsDialog({
              ...propsDialog,
              loading: false,
              message: t("administrateInvitedUsers.user.exist.disable"),
              warning: true,
            });
            setTimeout(() => {
              changeStateDialog("warning", false);
              changeStateDialog("message", "");
            }, 2500);
          })();
      }

      const usersCopy = [...invitedUsers.originalUsers];
      let fullDateStart = new Date();
      let dateStart = fullDateStart.getDate();
      let monthStart = fullDateStart.getMonth() + 1;
      let yearStart = fullDateStart.getFullYear();
      userInvitedCreated.data.lastInteraction = `${dateStart}/${monthStart}/${yearStart}`;

      let arraySignRequestExpirationDate =
        userInvitedCreated.data.lastInteraction.split("/");
      let dateParseExpirationDate =
        arraySignRequestExpirationDate[0] +
        "/" +
        moment(arraySignRequestExpirationDate[1])
          .format("MMM")
          .replace(/\./g, "") +
        "/" +
        arraySignRequestExpirationDate[2];
      userInvitedCreated.data.lastInteraction = dateParseExpirationDate;

      userInvitedCreated.data.isSignerNoPassword = userInvitedCreated.data.noPasswordRequired

      usersCopy.unshift(userInvitedCreated.data);

      setInvitedUsers({
        ...invitedUsers,
        originalUsers: usersCopy,
        filteredUsers: usersCopy,
      });

      setFilterAndSearchOptions({
        ...filterAndSearchOptions,
        filterOptions: "",
        filterSearch: "",
      });

      setPropsDialog({ ...propsDialog, loading: false, completed: true });
      setTimeout(() => {
        setInvitedUserData({
          ...invitedUserData,
          invitedEmail: "",
          fullName: "",
        });
        changeStateDialog("completed", false);
        setShowCreatingUser(false);
      }, 2500);
    } catch (e) {
      return (() => {
        changeStateDialog("loading", false);
        changeStateDialog("error", true);
        setTimeout(() => {
          changeStateDialog("error", false);
        }, 2500);
      })();
    }
  };

  const updateStatus = async () => {
    setOpenDialog(false);
    changeStateDialog("loading", true);
    try {
      const updateUserStatus = await userInvitedService.changeStatusInvited(
        selectedUser.email,
        token
      );

      if (updateUserStatus.statusCode !== 200)
        return (() => {
          changeStateDialog("loading", false);
          changeStateDialog('completed', true)
          changeStateDialog('message', '')
          changeStateDialog("error", true);
          setTimeout(() => {
            changeStateDialog("error", false);
            history.push("/configuration");
          }, 2500);
        })();

      const newUsers = [...invitedUsers.originalUsers];
      const changedUser = newUsers.findIndex(
        (item) => item.email === selectedUser.email
      );

      let fullDateStart = new Date();
      let dateStart = fullDateStart.getDate();
      let monthStart = fullDateStart.getMonth() + 1;
      let yearStart = fullDateStart.getFullYear();
      newUsers[
        changedUser
      ].lastInteraction = `${dateStart}/${monthStart}/${yearStart}`;

      let arraySignRequestExpirationDate =
        newUsers[changedUser].lastInteraction.split("/");
      let dateParseExpirationDate =
        arraySignRequestExpirationDate[0] +
        "/" +
        moment(arraySignRequestExpirationDate[1])
          .format("MMM")
          .replace(/\./g, "") +
        "/" +
        arraySignRequestExpirationDate[2];
      newUsers[changedUser].lastInteraction = dateParseExpirationDate;

      newUsers[changedUser].status = !newUsers[changedUser].status;

      const replaceObject = Object.assign({}, newUsers[changedUser]);

      newUsers.splice(changedUser, 1);
      newUsers.unshift(replaceObject);
      changeStateDialog("loading", false);
      let filteredUsers = [...newUsers];
      switch (filterAndSearchOptions.filterOptions) {
        case "all":
          break;
        case "active":
          filteredUsers = filteredUsers.filter((item) => item.status);
          break;
        case "inactive":
          filteredUsers = filteredUsers.filter((item) => !item.status);
          break;
        default:
          break;
      }
      setInvitedUsers({
        ...invitedUsers,
        originalUsers: newUsers,
        filteredUsers: filteredUsers.filter(
          (item) =>
            item.name
              .toLowerCase()
              .includes(filterAndSearchOptions.filterSearch.toLowerCase()) ||
            item.email
              .toLowerCase()
              .includes(filterAndSearchOptions.filterSearch.toLowerCase())
        ),
      });
      setSelectedUser({});
    } catch (e) {
      return (() => {
        changeStateDialog("loading", false);
        changeStateDialog("error", true);
        setTimeout(() => {
          changeStateDialog("error", false);
        }, 2500);
      })();
    }
  };

  const isMobile = useMediaQuery('(max-width:1025px)')
  const isMobileHorizontal = useMediaQuery('(max-width:1200px) and (orientation: landscape)')
  const isCompactView = isMobile || isMobileHorizontal

  /**
   * @function handleNoPasswordChange
   * @description Muestra modal de confirmación antes de activar/desactivar acceso sin contraseña
   * @param {Object} dataItem - Usuario a modificar
   * @param {boolean} checked - Nuevo estado del checkbox
   * @returns {void}
   */
  const handleNoPasswordChange = (dataItem, checked) => {
    const isSpecialCase = dataItem.showBtnReactive && dataItem.noPasswordRequired && !checked

    setNoPasswordConfirmData({
      user: dataItem,
      isActivating: checked,
      isPendingOnboarding: isSpecialCase
    });
    setShowNoPasswordConfirm(true);
  };

  /**
   * @function handleNoPasswordConfirmClose
   * @description Cierra el modal de confirmación sin realizar cambios
   * @returns {void}
   */
  const handleNoPasswordConfirmClose = () => {
    setShowNoPasswordConfirm(false);
    setNoPasswordConfirmData({ user: null, isActivating: false, isPendingOnboarding: false })
  };

  /**
   * @function handleNoPasswordConfirmSubmit
   * @description Ejecuta la actualización del estado sin contraseña después de confirmar
   * @returns {Promise<void>}
   */
  const handleNoPasswordConfirmSubmit = async () => {
    setShowNoPasswordConfirm(false);
    changeStateDialog('loading', true);

    const { user, isActivating, isPendingOnboarding } = noPasswordConfirmData;

    if (isPendingOnboarding) {
      try {
        const [resendResponse, updateResponse] = await Promise.all([
          userInvitedService.resendInvitation(token, user.email),
          userInvitedService.updateInvitedUserNoPassword(token, user.email, false)
        ])

        if (resendResponse && resendResponse.statusCode === 200 && updateResponse && updateResponse.statusCode === 200) {
          const updatedUsers = invitedUsers.originalUsers.map(u => {
            if (u.email === user.email) {
              return { ...u, isSignerNoPassword: false, noPasswordRequired: false }
            }
            return u
          })

          setInvitedUsers({
            originalUsers: updatedUsers,
            filteredUsers: updatedUsers
          })

          changeStateDialog('loading', false)

          setTimeout(() => {
            setPropsDialog({
              ...propsDialog,
              completed: true,
              message: t('administrateInvitedUsers.pendingOnboarding.success')
            })
          }, 100)

          setTimeout(() => {
            changeStateDialog('completed', false)
            changeStateDialog('message', '')
          }, 2800)
        } else {
          throw new Error(resendResponse?.message || updateResponse?.message || t('administrateInvitedUsers.pendingOnboarding.error'))
        }
      } catch (error) {
        console.error('Error sending onboarding for pending user:', error)
        changeStateDialog('loading', false)
        setPropsDialog({
          ...propsDialog,
          error: true,
          message: error.message || t('administrateInvitedUsers.pendingOnboarding.error')
        })

        setTimeout(() => {
          changeStateDialog('error', false)
          changeStateDialog('message', '')
        }, 2800)
      }

      setNoPasswordConfirmData({ user: null, isActivating: false, isPendingOnboarding: false })
      return
    }

    try {
      const response = await userInvitedService.updateInvitedUserNoPassword(
        token,
        user.email,
        isActivating
      );

      if (response && response.statusCode === 200) {
        const updatedUsers = invitedUsers.originalUsers.map(u =>
          u.email === user.email ? { ...u, isSignerNoPassword: isActivating, noPasswordRequired: isActivating } : u
        );

        setInvitedUsers({
          originalUsers: updatedUsers,
          filteredUsers: updatedUsers,
        });

        changeStateDialog('loading', false);

        setTimeout(() => {
          setPropsDialog({
            ...propsDialog,
            completed: true,
            message: isActivating
              ? t('administrateInvitedUsers.noPassword.activated.success')
              : t('administrateInvitedUsers.noPassword.deactivated.success')
          })
        }, 100)

        setTimeout(() => {
          changeStateDialog('completed', false)
          changeStateDialog('message', '')
        }, 2800)
      } else {
        throw new Error(response?.message || t('administrateInvitedUsers.noPassword.update.error'))
      }
    } catch (error) {
      console.error('Error updating no password status:', error);
      changeStateDialog('loading', false);
      setPropsDialog({
        ...propsDialog,
        error: true,
        message: error.message || t('administrateInvitedUsers.noPassword.update.error')
      })

      setTimeout(() => {
        changeStateDialog('error', false)
        changeStateDialog('message', '')
      }, 2800)
    }

    setNoPasswordConfirmData({ user: null, isActivating: false, isPendingOnboarding: false })
  };

  /**
   * @function handleResendInvitationClick
   * @description Muestra modal de confirmación para reenviar invitación
   * @param {Object} dataItem - Usuario al que se reenviará la invitación
   * @returns {void}
   */
  const handleResendInvitationClick = (dataItem) => {
    setResendInvitationUser(dataItem);
    setShowResendInvitationConfirm(true);
  };

  /**
   * @function handleResendInvitationClose
   * @description Cierra el modal de reenviar invitación sin realizar cambios
   * @returns {void}
   */
  const handleResendInvitationClose = () => {
    setShowResendInvitationConfirm(false);
    setResendInvitationUser(null);
  };

  /**
   * @function handleResendInvitationSubmit
   * @description Ejecuta el reenvío de invitación después de confirmar
   * @returns {Promise<void>}
   */
  const handleResendInvitationSubmit = async () => {
    setShowResendInvitationConfirm(false);
    changeStateDialog('loading', true);

    try {
      const response = await userInvitedService.resendInvitation(
        token,
        resendInvitationUser.email
      );

      if (response && response.statusCode === 200) {
        changeStateDialog('loading', false)

        setTimeout(() => {
          changeStateDialog('completed', true)
        }, 100)

        setTimeout(() => {
          changeStateDialog('completed', false)
          changeStateDialog('message', '')
        }, 2800)

      } else {
        throw new Error(response.message || t('administrateInvitedUsers.resendInvitation.error'))
      }
    } catch (error) {
      console.error('Error resending invitation:', error);
      changeStateDialog('loading', false);
      changeStateDialog('error', true);
      changeStateDialog(
        'message',
        error.message || t('administrateInvitedUsers.resendInvitation.error')
      );
    }

    setResendInvitationUser(null);
  };


  useEffect(() => {
    getUsers();
    getDomains();
  }, []);

  return (
    <div className="standard-wrapper">
      {isLoading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} className="wrapper-styles">
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            style={containerTableAndHeadersStyles}
          >
            {showCreatingUser ? (
              <>
                <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                  <HeaderHLPure title={t("administrateInvitedUsers.create.user.guest")} />
                </Grid>
                <Grid
                  container
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  style={{
                    padding: "5% 5% 0 5%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Grid xs={12} lg={12} md={12} sm={12} es={12}>
                    <InputHLPure
                      handleChangeInput={(e) =>
                        updateUserData("invitedEmail", e.target.value)
                      }
                      labelInput={t("administrateInvitedUsers.email.guest")}
                      inputActive
                      valueInput={invitedUserData.invitedEmail}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    style={{ marginTop: "20px" }}
                  >
                    <InputHLPure
                      handleChangeInput={(e) =>
                        updateUserData("fullName", e.target.value)
                      }
                      labelInput={t("administrateInvitedUsers.name.complete.guest")}
                      inputActive
                      valueInput={invitedUserData.fullName}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Grid style={{ marginRight: "10px" }}>
                      <ButtonHLPure
                        nameBtn={t("button.cancel")}
                        onClickBtn={() => {
                          setShowCreatingUser(false);
                          setInvitedUserData({
                            ...invitedUserData,
                            fullName: "",
                            invitedEmail: "",
                          });
                        }}
                      />
                    </Grid>
                    <Grid>
                      <ButtonHLPure
                        onClickBtn={createUser}
                        primary
                        nameBtn={t("administrateInvitedUsers.create.guest")}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                  <HeaderHLPure title={t("administrateInvitedUsers.title")} />
                </Grid>
                <Grid
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="filters-styles"
                >
                  <Grid className="margin-buttons">
                    <ButtonAddHLPure
                      onClickBtn={() => setShowCreatingUser(true)}
                      iconAdd
                      nameBtn={t("administrateInvitedUsers.btn.add.guest")}
                    />
                  </Grid>
                  <Grid className="margin-buttons">
                    <SearchBarHLPure
                      defaultValue={filterAndSearchOptions.filterSearch}
                      onSearchChange={(e) => {
                        setFilterAndSearchOptions({
                          ...filterAndSearchOptions,
                          filterSearch: e.target.value,
                        });
                        searchUsers(e.target.value);
                      }}
                      placeholder={t("administrateInvitedUsers.search.by.guest")}
                    />
                  </Grid>
                  <Grid>
                    <DropDownBtnHLPure
                      onDropDownChange={(e) => {
                        setFilterAndSearchOptions({
                          ...filterAndSearchOptions,
                          filterOptions: e.target.value,
                        });
                        filterUsers(e.target.value);
                      }}
                      optionsDropDown={filterOptions}
                      valueItem={'status'}
                      nameOption={'optionName'}
                      optionsValue={filterAndSearchOptions.filterOptions}
                    />
                  </Grid>
                </Grid>
                <Grid>
                  <GridHLPure
                    dataGrid={invitedUsers.filteredUsers}
                    onSelectedItem={setSelectedUser}
                    skip={0}
                    take={6}
                    titleRow1={t("administrateInvitedUsers.grid.title.1")}
                    fieldRow1={"name"}
                    fieldSubtitle={"email"}
                    column2Status={!mobile}
                    field2Status={"status"}
                    title2Status={t("administrateInvitedUsers.grid.title.2")}
                    columnThree={!tinyMobile}
                    titleRow3={t("administrateInvitedUsers.grid.title.3")}
                    fieldRow3={"lastInteraction"}
                    columnFour
                    titleRow4={!tinyMobile ? t("administrateInvitedUsers.grid.title.4") : ""}
                    iconOneActive
                    activeDialog1
                    btnOpenDialog1={(dataItem) => {
                      setOpenDialog(true);
                      setSelectedUser(dataItem);
                    }}
                    cellColumnStatus={statusCell}
                    labelOneActions={t("administrateInvitedUsers.grid.actions.disable")}
                    styleCol1="col-1-styles"
                    mobileFunction

                    columnNoPassword={!isCompactView}
                    fieldNoPassword={'isSignerNoPassword'}
                    titleNoPassword={t('userAdministrationView.no.password.column')}
                    tooltipNoPassword={t('userAdministrationView.no.password.column.tooltip')}
                    onNoPasswordChange={handleNoPasswordChange}

                    iconFifthActive
                    activeDialog5
                    btnOpenDialog5={handleResendInvitationClick}
                    labelFifthActions={t('administrateInvitedUsers.grid.actions.resendInvitation')}
                    showIconFiveCondition={(dataItem) => dataItem.showBtnReactive}
                  />
                </Grid>
              </>
            )}
          </Container>
          {!showCreatingUser &&
            <Grid
              container
              style={{ justifyContent: "flex-end" }}
            >
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={() => history.push("/configuration")}
              />
            </Grid>
          }
        </Container>
      )}
      {openDialog && (
        <DialogSystemGLPure
          showConfirm={true}
          handleConfirmDeleteFlowClose={() => setOpenDialog(false)}
          confirmTitle={
            selectedUser.status ? t("administrateInvitedUsers.disable.user") : t("administrateInvitedUsers.enable.user")
          }
          labelCancelConfirmation={t("button.cancel")}
          labelSubmitConfirmation={selectedUser.status ? t("administrateInvitedUsers.disable") : t("administrateInvitedUsers.enable")}
          handleConfirmDeleteFlowSubmit={updateStatus}
          confirmMessage={`${t("administrateInvitedUsers.modal.disable.question")} ${selectedUser.status ? t("administrateInvitedUsers.modal.disable.question.2") : t("administrateInvitedUsers.modal.disable.question.2.enable")}?`}
        />
      )}
      <DialogSystemGLPure
        showLoadingRequesting={propsDialog.loading}
        showCompletedRequesting={propsDialog.completed}
        showErrorRequesting={propsDialog.error}
        showWarningRequesting={propsDialog.warning}
        toggleLoadingRequesting={() =>
          changeStateDialog("loading", !propsDialog.loading)
        }
        toggleCompletedRequesting={() =>
          changeStateDialog("completed", !propsDialog.completed)
        }
        toggleErrorRequesting={() =>
          changeStateDialog("error", !propsDialog.error)
        }
        toggleWarningRequesting={() =>
          changeStateDialog("warning", !propsDialog.warning)
        }
        message={propsDialog.message}
        showConfirm={showNoPasswordConfirm || showResendInvitationConfirm}
        confirmTitle={
          showResendInvitationConfirm
            ? t('administrateInvitedUsers.resendInvitation.confirm.title')
            : noPasswordConfirmData.isPendingOnboarding
              ? t('administrateInvitedUsers.pendingOnboarding.title')
              : noPasswordConfirmData.isActivating
                ? t('administrateInvitedUsers.noPassword.activate.title')
                : t('administrateInvitedUsers.noPassword.deactivate.title')
        }
        confirmMessage={
          showResendInvitationConfirm
            ? t('administrateInvitedUsers.resendInvitation.confirm.message')
            : noPasswordConfirmData.isPendingOnboarding
              ? t('administrateInvitedUsers.pendingOnboarding.message')
              : noPasswordConfirmData.isActivating
                ? t('administrateInvitedUsers.noPassword.activate.message')
                : t('administrateInvitedUsers.noPassword.deactivate.message')
        }
        handleConfirmDeleteFlowClose={
          showResendInvitationConfirm
            ? handleResendInvitationClose
            : handleNoPasswordConfirmClose
        }
        handleConfirmDeleteFlowSubmit={
          showResendInvitationConfirm
            ? handleResendInvitationSubmit
            : handleNoPasswordConfirmSubmit
        }
        labelCancelConfirmation={t('button.cancel')}
        labelSubmitConfirmation={t('button.confirm')}
      />
    </div>
  );
};

export default AdministrateInvitedUsers;
